<script lang="ts" setup>
import { HttpStatusCode } from "axios";
import type LxcError from "~/core/models/LxcError.class";
import type { RelationEntity } from "~/modules/relation/models/RelationEntity.interface";

defineProps<{
  parentAffiliation?: RelationEntity;
  error?: LxcError;
}>();
</script>

<template>
  <!-- do not display the parent affiliation if it does not exist -->
  <!-- display the error if it is different from not found -->
  <div
    v-if="
      parentAffiliation || (error && error.status !== HttpStatusCode.NotFound)
    "
    class="mb-5"
  >
    <div class="mb-4">
      {{ $t("administration.relations.affiliations.parentEntity.title") }}
    </div>

    <error-component v-if="error" :error="error" />

    <div v-else-if="parentAffiliation">
      <relation-entity from-to="from" :relation-entity="parentAffiliation" />
    </div>
  </div>
</template>
